module.exports = __webpack_public_path__ + "fonts/ToyotaType-Book.3c5156b.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-Book.woff2
// module id = 34Es
// module chunks = 13